import type { ReactNode } from 'react';
import './ui.css';

type Tone = 'success' | 'warning' | 'danger' | 'neutral' | 'info';

interface BadgeProps {
  children: ReactNode;
  tone?: Tone;
}

export function Badge({ children, tone = 'neutral' }: BadgeProps) {
  return <span className={`ui-badge ui-badge--${tone}`}>{children}</span>;
}

interface AlertProps {
  tone?: Tone;
  children: ReactNode;
}

export function Alert({ tone = 'info', children }: AlertProps) {
  return <div className={`ui-alert ui-alert--${tone}`}>{children}</div>;
}
